<template>
    <div class="row">
        <h1>Desarrollos</h1>
        <hr>
        <Product />
    </div>
</template>

<script>
    import Product from '../components/Product.vue'
    export default {
        components:{
            Product
        }
    }
</script>